import type { Maybe, PinterestSettings } from '@types/gatsby-types';
import { graphql, useStaticQuery } from 'gatsby';

const query = graphql`
    query PinterestPixelIdQuery {
        settings {
            pinterest {
                enabled
                pixelId
            }
        }
    }
`;

type PinterestPixelIdQuery = {
    settings: Maybe<{
        pinterest: Maybe<Pick<PinterestSettings, 'pixelId'>>;
    }>;
};

type UsePinterestPixelId = {
    enabled: boolean;
    pixelId: string | null;
};

export default function usePinterestPixelId(): UsePinterestPixelId {
    const { settings } = useStaticQuery<PinterestPixelIdQuery>(query);

    return {
        enabled: !!settings?.pinterest?.enabled,
        pixelId: settings?.pinterest?.pixelId ?? null,
    };
}
